<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.smAndDown"
                show-arrows
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="text-capitalize text-left text-sm-center d-flex justify-start justify-sm-center px-3"
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "Coupons",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        ...mapState(["superUser"]),
        
        lang() {
            return this.$route.params.lang;
        },

        permissions() {
            return this.$store.state.permissions.coupons
                ? this.$store.state.permissions.coupons
                : { goal: {}, voucher: {}, product: {}, discount: {} };
        },

        tabs() {
            let arr = [];

            if (this.superUser || this.permissions.goal && this.permissions.goal.read) {
                arr.push({
                    name: { el: "Κουπόνια με Συναλλαγές", en: "coupons with transactions", it: "Buoni con Transazioni" },
                    to: `/${this.lang}/storePanel/coupons/with-transactions`,
                });
            }

            if (this.superUser || this.permissions.voucher && this.permissions.voucher.read) {
                arr.push({
                    name: { el: "Κουπόνια με Κωδικό", en: "coupons with code", it: "Buoni con Codice" },
                    to: `/${this.lang}/storePanel/coupons/with-code?page=1`,
                });
            }

            if (this.superUser || this.permissions.product && this.permissions.product.read) {
                arr.push({
                    name: { el: "Κουπόνια σε Προϊόντα", en: "coupons on products", it: "Buoni sui Prodotti" },
                    to: `/${this.lang}/storePanel/coupons/on-products?page=1`,
                });
            }

            if (this.superUser || this.permissions.discount && this.permissions.discount.read) {
                arr.push({
                    name: { el: "Κουπόνια με Έκπτωση", en: "coupons with discount", it: "Buoni con Sconto" },
                    to: `/${this.lang}/storePanel/coupons/with-discount?page=1`,
                });
            }

            return arr;
        },
    },

    watch: {
        tabs: {
            immediate: true,
            handler(val) {
                if (val.length) {
                    if (
                        this.$route.path === `/${this.lang}/storePanel/coupons`
                    ) {
                        this.$router.replace(val[0].to);
                    }
                }
            },
        },
    },
};
</script>

<style scoped>
.dashed {
    border: 1px dashed grey;
    border-radius: 10px;
}
</style>
